import { render, staticRenderFns } from "./guanqiaEndLog.vue?vue&type=template&id=75667c36&"
import script from "./guanqiaEndLog.vue?vue&type=script&lang=js&"
export * from "./guanqiaEndLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75667c36')) {
      api.createRecord('75667c36', component.options)
    } else {
      api.reload('75667c36', component.options)
    }
    module.hot.accept("./guanqiaEndLog.vue?vue&type=template&id=75667c36&", function () {
      api.rerender('75667c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/guanqiaEndLog.vue"
export default component.exports